import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { signUp } from '../actions'
import { Field, reduxForm } from 'redux-form'


class SignUp extends Component {

    renderinput = ({ input, meta, title, type }) => {
        const classname=`seven wide field ${meta.error && meta.touched?'error':''}`
        return (
            <div className={classname}>
                <label>{ title }</label>
                <input {...input} type={type} />
                {this.rendererror(meta)}
            </div>
        )
    }

    
    rendererror = ({touched, error}) => {
        if (touched && error) {
            return (
                 <div className="ui error message">
                    <div className="header">{ error }</div>
                </div>
            )
        }
    }
    state = {
        passclass: 'password',
        err: null,
        loading: false,
        btnname:"ui primary button"
    }
    onInputChange = (e) => {
        this.setState({
            [e.target.id]:e.target.value
        })
    }
    onCheck = (e) => {
        if (e.target.checked) {
           
            this.setState({
                passclass:'text'
            })
        } else {
            this.setState({
                passclass:'password'
            })
        }
       
    }
    onFormSubmit = (values) => {
         this.setState({
            loading: true,
            btnname:"ui primary loading button"
          })
      setTimeout(() => {
           this.setState({
            loading: false,
            btnname:"ui primary button"
          })
      }, 1500);
       
            this.props.signUp({ ...values })
        
        
    }
    render() {
        const { auth } = this.props
        
        if(auth.uid) return <Redirect to="/"/>
        return (
            <form className="ui form error" style={{ marginTop: '25px' }} onSubmit={this.props.handleSubmit(this.onFormSubmit)}>
                <h2 style={{fontSize:"32px"}}>Sign Up</h2>

                    <Field type="text" name="firstName" placeholder="First Name" component={this.renderinput} title="enter first name" />
                
               
                    <Field type="text" name="lastName" placeholder="Last Name" component={this.renderinput} title="enter last name" />
               
              
                   
                    <Field type="text" name="email" placeholder="E-mail" component={this.renderinput} title="enter your E-mail" />
               
                
                 <div className=" fields">
                
                    <Field type={this.state.passclass} name="password" placeholder="Password" component={this.renderinput} title="enter password" />
                
               
                <div className=" four wide field" style={{marginTop:'33PX'}}>
                 <div className="ui radio checkbox">
                    <input type="checkbox" tabIndex="0" onClick={this.onCheck} />
                    <label style={{fontWeight:"bold"}}>Show Password</label>
                 </div>
                    </div>
                    </div>
                {this.state.err ? <div className="seven wide field ui error message">
                    <div className="header">{ this.state.err}</div>
                </div>:null}
                <button type="submit" className={this.state.btnname} disabled={this.state.loading}>
                    Sign Up
                    </button>
                
            </form>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        error:state.auth.errmsg
        
    }
}
const validate = (values) => {
    const error = {}
    if (!values.firstName) {
       error.firstName="you must enter first name"
    }
    if (!values.lastName) {
        error.lastName="you must enter last name"
    }
    if (!values.email) {
        error.email="you must enter an email"
    } else if(!values.email.match(/.+@.+..+/)) {
         error.email="you must enter a valid email"
    }
     
    if (!values.password) {
        error.password="you must enter a password"
    } else {
        if (values.password.length < 6) {
            error.password="your password is too short"
        }
    }
    return error
}
const combinedForm = reduxForm({
    form: 'signup',
    validate
})(SignUp)
export default connect(mapStateToProps,{signUp}) (combinedForm)